import {FieldRelationship} from "Fields/Components";
import Style from "./profile-field-relationship.scss";
import {html, nothing} from "Application.js";
import {ProfileRepository} from "../../Repositories/ProfileRepository.js";
import {ProfileRelation} from "../../Models/Fields/ProfileRelation.js";

export class ProfileFieldRelationship extends FieldRelationship {

	constructor() {
		super();
		this.profileRepository = new ProfileRepository();
	}

	loadSelection(searchValue, exclude) {
		return this.profileRepository.list({
			Name: `%${searchValue}%`,
			Exclude: exclude
		});
	}

	static styles = [super.styles, Style];

	renderSelectionEntry(profile, index) {
		return this.renderProfile(profile.ID, profile, true);
	}

	renderSuggestion(relation, index) {
		return this.renderProfile(relation.ID, relation.Profile, true);
	}

	renderRelation(relation) {
		return this.renderProfile(relation.ID, relation.Profile, false);
	}

	renderProfile(id, profile, inSelection) {
		return html`
			<div class="relation">
				<div class="left">
					<portfolio-logo size="small" icon="business" .src=${profile.LogoURL}></portfolio-logo>
				</div>
				<div class="middle">
					<div class="name">
						<div class="link" @click=${() => window.App.ProfileDialog.open(parseInt(id))}>${profile.Name}</div>
						${profile.LegalForm ? html`<span class="legalForm">${profile.LegalForm}</span>` : nothing}
					</div>
				</div>
				${this.inEditMode ? html`
					<div class="right">
						${inSelection ? html`
							<aui-icon-button @action=${() => this.addRelation(new ProfileRelation({ ID: id, Profile: profile }))}>add_circle_outline</aui-icon-button>
						` : html`
							<aui-icon-button class="danger" @action=${() => this.removeRelation(id)}>remove_circle_outline</aui-icon-button>
						`}
					</div>
				` : nothing}
			</div>
		`;
	}

}

customElements.define("profile-field-relationship", ProfileFieldRelationship);